export default "__VITE_ASSET__Ci2hXXZt__"